/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useSelector } from 'react-redux';
import NoSsr from '@material-ui/core/NoSsr';

// app: components
import CollectionPrivacyStatus from 'components/CollectionPrivacyStatus';
import CollectionOptionsMenu from 'components/Collection/OptionsMenu';
import FavouriteButton from 'components/FavouriteButton';
import Icon from 'components/Icon';

// app modules: props
import CollectionsProps from 'components/Collection/CollectionsProps';

// app modules: constants
import { COLOURS, CONTENT_TYPES } from 'constants/index';

// assets
import CssHeroButtons from './HeroButtons.scss';

function CollectionHeroButtons(props) {
  const { collection, imageSrc, imageSrcSet } = props;
  useStyles(CssHeroButtons);
  const isCkbkEditor = useSelector(
    state => state.user.permissions && state.user.permissions.includes('collections:edit'),
  );
  const userId = useSelector(state => state.user.id);

  const thumbnail = <img width="100" height="100" src={imageSrc} srcSet={imageSrcSet} alt="" />;

  return (
    <div className="collection-hero-buttons margin-top-15">
      {collection.can_edit ? (
        <CollectionOptionsMenu
          collection={collection}
          className="collection-hero-buttons__privacy"
          subMenu="privacy"
          styleButton={false}
        >
          <CollectionPrivacyStatus visibility={collection.visibility} />
        </CollectionOptionsMenu>
      ) : null}

      <div className="collection-hero-buttons__actions">
        <FavouriteButton
          contentId={collection.id}
          contentType={CONTENT_TYPES.COLLECTION}
          buttonClassName="collection-hero-buttons__action"
        />
        <NoSsr>
          <CollectionOptionsMenu
            collection={collection}
            heading={collection.name}
            image={thumbnail}
            shareImageUrl={imageSrc}
            className="collection-hero-buttons__action"
            subMenu="share"
          >
            <Icon
              fill={COLOURS.ENERGIZED}
              name="native-share"
              height="20"
              width="20"
              style={{ marginTop: -3 }}
            />
          </CollectionOptionsMenu>
          {userId !== collection.user_id && !isCkbkEditor ? null : (
            <CollectionOptionsMenu
              collection={collection}
              heading={collection.name}
              image={thumbnail}
              shareImageUrl={imageSrc}
              className="collection-hero-buttons__action"
            >
              <Icon fill={COLOURS.ENERGIZED} name="dots" height="22" width="22" />
            </CollectionOptionsMenu>
          )}
        </NoSsr>
      </div>
    </div>
  );
}

CollectionHeroButtons.propTypes = {
  collection: CollectionsProps.collection.isRequired,
  imageSrc: PropTypes.string,
  imageSrcSet: PropTypes.string,
};

CollectionHeroButtons.defaultProps = {
  imageSrc: null,
  imageSrcSet: null,
};

export default CollectionHeroButtons;
